import { Button } from '@material-ui/core'
import Cancel from '@material-ui/icons/Cancel'
import React from 'react'
import { useFormUploadFiles, useFormUploadFilesProgress } from '../../../context/FormUploadContext'
import LoadingMin from '../../../customs/LoadingMin/LoadingMin'
import { humanFileSize } from '../../../utils/humanFileSize'
import { useStylesUpload } from './stylesUpload'

interface iUploadFiles {
  name: string
  disabled?: boolean
}

const UploadFiles = ({ name, disabled }: iUploadFiles) => {
  const classes = useStylesUpload()

  const { filesUploaded, filesUploading, cancelFile, deleteFile } = useFormUploadFiles(name)
  // TODO progress do samostatne komponenty
  const { progress } = useFormUploadFilesProgress()

  if (disabled && !filesUploaded.length && !filesUploading.length) {
    return <div> Žádné soubory </div>
  }

  return (
    <div>
      {filesUploaded.map((file) => (
        <div key={file.id} className={classes.file__content}>

          <div className={classes.file__name_wrapper}>
            <span className={classes.file__name_wrapper__name} title={file.fileData.name}>{file.fileData.name}</span>
          </div>

          <div>
            {file.fileData.size && ` (${humanFileSize(file.fileData.size)})`}
          </div>

          <div className={classes.file__btn}>
            {!disabled && (
              <Button size="small" variant="contained" color="secondary" onClick={() => deleteFile(file.id)}>
                <Cancel/>
              </Button>
            )}
          </div>

        </div>
      ))}

      {filesUploading.map((file) => (
        <div key={file.id} className={classes.file__content}>
          <div className={classes.file__name_wrapper}>
            <span className={classes.file__name_wrapper__name} title={file.fileData.name}>{file.fileData.name}</span>
          </div>

          <div>
            <LoadingMin/> {progress[file.id]} %
          </div>

          <div className={classes.file__btn}>
            <Button size="small" variant="contained" color="secondary" onClick={() => cancelFile(file.id)}>
              <Cancel/>
            </Button>
          </div>
        </div>
      ))}
    </div>
  )
}

export default UploadFiles
